import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MdMoreVert } from "react-icons/md";

function MenuButton({
  deleteClick,
  imageEditModal,
  // variationEditModal,
  editDetails,
  sizeUpdate,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <MdMoreVert
        className="p-2 h-10 w-10 rounded-full mx-2 text-black bg-[#ffe1a1] cursor-pointer"
        onClick={handleClick}
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      />
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 60,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        // anchorOrigin={{
        //   vertical: "right",
        //   horizontal: "top",
        // }}
        // transformOrigin={{
        //   vertical: "right",
        //   horizontal: "bottom",
        // }}
      >
        <MenuItem
          onClick={editDetails}
          sx={{
            fontFamily: "Poppins",
          }}
        >
          Update Product Details
        </MenuItem>
        {/* <MenuItem
          onClick={variationEditModal}
          sx={{
            fontFamily: "Poppins",
          }}
        >
          Edit Variation
        </MenuItem> */}
        <MenuItem
          onClick={imageEditModal}
          sx={{
            fontFamily: "Poppins",
          }}
        >
          Update Colors
        </MenuItem>
        <MenuItem
          onClick={sizeUpdate}
          sx={{
            fontFamily: "Poppins",
          }}
        >
          Update Sizes
        </MenuItem>
        <MenuItem
          onClick={deleteClick}
          sx={{
            fontFamily: "Poppins",
            color: "red",
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
}

export default MenuButton;
